import InterRadioGroup from './RadioGroup';
import InterRadioItem from './RadioItem';

type InterRadioGroupType = typeof InterRadioGroup;

interface RadioGroupInterface extends InterRadioGroupType {
  Item: typeof InterRadioItem;
}

const RadioGroup = InterRadioGroup as RadioGroupInterface;
RadioGroup.Item = InterRadioItem;

export default RadioGroup;
